import { render, staticRenderFns } from "./SignatureList.vue?vue&type=template&id=2a39d4e1&scoped=true"
import script from "./SignatureList.vue?vue&type=script&lang=js"
export * from "./SignatureList.vue?vue&type=script&lang=js"
import style0 from "./SignatureList.vue?vue&type=style&index=0&id=2a39d4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39d4e1",
  null
  
)

export default component.exports